import script from "./procureSendDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./procureSendDetail.vue?vue&type=script&setup=true&lang=js"

import "./procureSendDetail.vue?vue&type=style&index=0&id=892d5396&lang=less"

const __exports__ = script;

export default __exports__